var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Will not exist in Node.js envs, use with care
/* global window */

import mergeWith from 'lodash/mergeWith';
import merge from 'lodash/merge';

import debounce from 'debounce';
import isString from 'lodash/isString';
import v4 from 'uuid/v4';

import { events, provider, utils as eventBuilderUtils } from '@spt-tracking/pulse-event-builders';
import { syncWithCis } from '@spt-tracking/pulse-cis-sync';

import EventQueue from '@spt-tracking/event-queue-js';

import send from './network';

import DEFAULT_CONFIG from './config';

var SDK_VERSION = '4.3.3';

var EXPERIMENTATION_GLOBAL_NAME = 'AdevintaExperimentation';

var providerSdrn = provider.sdrn;
var evaluateAndFlatten = eventBuilderUtils.evaluateAndFlatten;


function getEventTrackingMethod(name) {
  return events[name] || events.trackerEvent;
}

/**
 * SDKConfigInput
 *
 * Override default settings of the SDK
 *
 * See `src/config-browser.js` and `src/config.js` for the default values for
 * browser and no browser environments.
 *
 * **Note**
 * - that the `username` and `password` are *for Node.js environments only*.
 * - that `globalVarNames` and `useExperimentation` are *for browser environments only*.
 */


/**
 * Internal state of the tracker.
 *
 * **Note**
 * - that the `username` and `password` are *for Node.js environments only*.
 * - that `globalVarNames` and `useExperimentation` are *for browser environments only*.
 */


/**
 * Input for event builders. Different events will read and process different
 * fields. See
 * [@spt-tracking/pulse-event-builders](https://github.mpi-internal.com/spt-dataanalytics/pulse-event-builders)
 * for details.
 *
 * You can in general pass any data to any part of the event, only the processed
 * fields are documented.
 */


/**
 * Optional option used in `track` and `trackPageView`
 *
 * If `resolveOnQueued` is set to true then the promise returned by `track`/`trackPageView` will
 * resolved when the event is evaluated and added to to the internal queue. If it is falsy (default
 * value us `undefined`) the promise will resolve when the event have been transmitted over the
 * network.
 */

var Tracker = function () {

  /**
   * @param {string} providerId (*required*). Id of the site or app. Should be
   * registered in [huginn](https://bifrost.schibsted.io/huginn)
   */
  function Tracker(providerId, config, builders) {
    var _this = this;

    _classCallCheck(this, Tracker);

    if (!providerId || !isString(providerId)) {
      throw new Error('Required parameter `providerId` missing');
    }
    this.state = merge({}, DEFAULT_CONFIG, {
      pageViewId: v4(),
      providerId: providerId
    }, config);

    this.queue = new EventQueue();

    // Move to default config?
    this.builders = merge({}, builders, {
      provider: {
        id: providerId
      },
      tracker: {
        version: SDK_VERSION + '-' + 'cd607f02457c90288467e331c77433ce59e31d87'.slice(0, 5)
      }
    });

    // This is technically/strictly speaking not necessary to do before the
    // first event which requires an environmentId is sent. This will in most
    // cases be all events on client-instances and doing this immediately will
    // unblock the first event faster.

    // The reason for the timeout is to cover the case of
    // const tracker = new Tracker();
    // tracker.login('user@example.org');
    if (this.state.environment === 'browser') {
      setTimeout(function () {
        _this.cisSync();
      }, 10);

      if (window && window.navigator && window.navigator.sendBeacon) {
        window.addEventListener('pagehide', function () {
          _this.state.useBeacon = true;
          _this._sendImmediately();
        });
      }
      // Update global variable names to include experimentation
      if (window && this.state.useExperimentation) {
        this.state.globalVarNames.push(EXPERIMENTATION_GLOBAL_NAME);
      }
    }
  }

  _createClass(Tracker, [{
    key: 'cisSync',
    value: function cisSync() {
      var _builders$actor = this.builders.actor,
          actor = _builders$actor === undefined ? {} : _builders$actor;
      var id = actor.id;
      var _state = this.state,
          nativeJwe = _state.nativeJwe,
          cisBaseUrl = _state.cisBaseUrl;

      return syncWithCis(id, nativeJwe, cisBaseUrl);
    }

    /**
     * Add event to the tracker event queue
     *
     * The input data is a can be objects, arrays, primitives or promises. The
     * order of calls to the method is not guaranteed to be sent in the same
     * sequence.
     *
     * ```
     * tracker.track('trackerEvent', {
     * actor: new Promise(resolve => setTimeout(() => resolve('person@example.org'), 2000))
     * });
     * tracker.track('trackerEvent', { type: 'Engagement '});
     *
     * ```
     *
     * The second call to `track` will be added to the event queue before the
     * first since all input to events are resolved before being added to the
     * internal queue. Setting the future value in the SDK state will block all
     * events and events will be added to the queue in order.
     *
     * ```
     * tracker.update({
     * actor: new Promise(resolve =>
     * setTimeout(() => resolve('person@example.org'), 2000)) })
     * tracker.track('trackerEvent', { type: 'View' });
     * tracker.track('trackerEvent', { type: 'Engagement' });
     * ```
     *
     * Both of these events will be blocked for two seconds and executed in order.
     *
     * @param {string} eventType. See [spt-tracking/pulse-event-builders]() for
     * available event types
     * @param {object} data. input data to the given event. The given data and the
     * persisted data in the tracker will be merged before passing it to the event
     * function.
     *
     */

  }, {
    key: 'track',
    value: function track(eventType, data, options) {
      var _this2 = this;

      var _track = function _track() {
        return _this2.evaluateEvent(eventType, data).then(function (event) {
          var promise = _this2._push(event, options);
          _this2.send();
          return promise;
        });
      };
      return this.cisSync().then(_track, _track);
    }

    /**
     * Evaluate all input given to the sdk/this method and pass it through the
     * appropriate event formatter.
     *
     */

  }, {
    key: 'evaluateEvent',
    value: function evaluateEvent(eventType, data) {
      var _this3 = this;

      var eventBuilder = getEventTrackingMethod(eventType);
      return this.evaluateEventInputs(eventType, data).then(function (input) {
        return evaluateAndFlatten(eventBuilder(input, _this3.state));
      });
    }
  }, {
    key: 'evaluateEventInputs',
    value: function evaluateEventInputs(eventType, data) {
      var eventDefaults = getEventTrackingMethod(eventType).defaults;
      this.update(this._getDataFromGlobalVars());
      return Promise.all([evaluateAndFlatten(this.builders), evaluateAndFlatten(data)]).then(function (builders) {
        var eventInput = builders.reduce(function (accl, p) {
          return merge(accl, p);
        }, {});
        return merge({}, eventDefaults(), eventInput);
      });
    }

    /**
     * Return a new Tracker with the current state
     */

  }, {
    key: 'clone',
    value: function clone() {
      return new Tracker(this.state.providerId, _extends({}, this.state), _extends({}, this.builders));
    }

    /**
     * Update the persisted state that is passed to all events
     *
     * Calling
     * ```
     * tracker.update({ actor: 'person@example.org' });
     * tracker.trackPageView();
     * tracker.trackPageView();
     * ```
     *
     * is equivalent of doing
     *
     * ```
     * tracker.trackPageView({ actor: 'person@example.org' });
     * tracker.trackPageView({ actor: 'person@example.org' });
     * ```
     *
     * @param {Object} builder data passed to event functions
     *
     * @param {boolean} mergeBuilder the given data will be merged deeply with the
     * existing state. False will result in the previous state being overwritten
     *
     */

  }, {
    key: 'update',
    value: function update(builder) {
      var mergeBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      function conflictResolver(objValue, srcValue) {
        if (objValue instanceof Promise || srcValue instanceof Promise) {
          return Promise.all([objValue, srcValue]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                obj = _ref2[0],
                src = _ref2[1];

            return mergeWith({}, obj, src, conflictResolver);
          });
        }
        return undefined;
      }

      if (mergeBuilder) {
        this.builders = mergeWith({}, this.builders, builder, conflictResolver);
      } else {
        this.builders = Object.assign({}, this.builders, builder);
      }
    }

    /**
     * Get the environment id from the current browser. A promise is returned
     * because a CIS call is done to generate a new environmentId if no cookie is
     * found.
     *
     * *Note*: This method will return a Promise that is always rejected on node
        environments.
     */

  }, {
    key: 'getEnvironmentId',
    value: function getEnvironmentId() {
      return this.cisSync().then(function (_ref3) {
        var environmentId = _ref3.environmentId;
        return environmentId;
      });
    }

    /**
     * Returns the UUID currently y used as the page view (will be muted by
     * `newPageView` and `trackPageView`).
     */

  }, {
    key: 'getPageViewId',
    value: function getPageViewId() {
      return this.state.pageViewId;
    }

    /**
     * Set a page view id. Will be attached to all events until a new
     * id is generated.
     */

  }, {
    key: 'setPageViewId',
    value: function setPageViewId(id) {
      this.state.pageViewId = id;
    }

    /**
     * Generate a new page view id. Will be attached to all events until a new
     * id is generated.
     */

  }, {
    key: 'newPageView',
    value: function newPageView() {
      this.state.pageViewId = v4();
    }

    /**
     * @private
     */

  }, {
    key: '_getCollectorPath',
    value: function _getCollectorPath(providerId) {
      var _state2 = this.state,
          collectorBaseUrl = _state2.collectorBaseUrl,
          collectorPath = _state2.collectorPath,
          environment = _state2.environment;

      if (environment === 'node') {
        return collectorBaseUrl + '/' + collectorPath;
      }
      var _provider = providerId || this.state.providerId;
      if (isString(_provider) && _provider.indexOf('sdrn') === 0) {
        return collectorBaseUrl + '/' + collectorPath + '/' + _provider;
      }
      return collectorBaseUrl + '/' + collectorPath + '/' + providerSdrn(_provider);
    }
  }, {
    key: '_getDataFromGlobalVars',
    value: function _getDataFromGlobalVars() {
      var dataFromGlobals = {};
      if (typeof window === 'undefined') {
        return {};
      }
      this.state.globalVarNames.forEach(function (globalName) {
        if (window[globalName] && _typeof(window[globalName]) === 'object') {
          try {
            dataFromGlobals = _extends({}, dataFromGlobals, window[globalName]);
          } catch (error) {
            // Any issues parsing global variable, it is skipped.
          }
        }
      });
      return dataFromGlobals;
    }

    /**
     * Send all events that are in the internal event queue.
     *
     * The returned Promise will resolve with 'true' when all events have been
     * successfully transmited. These events will have been removed from the event
     * queue. If the promise rejects it means that the event queue could not be
     * sent. Events that are unsuccessfully sent will remain in the event queue.
     *
     * @private
     *
     */

  }, {
    key: '_sendImmediately',
    value: function _sendImmediately() {
      var _this4 = this;

      if (this.queue.getQueuedEvents().length === 0) {
        return Promise.resolve(true);
      }

      return this.cisSync().then(function () {
        var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            doTracking = _ref4.doTracking;

        if (!doTracking) {
          return Promise.resolve(true);
        }
        var url = _this4._getCollectorPath(_this4.state.providerId);
        var sendHandler = function sendHandler(data) {
          return send(url, data, _this4.state);
        };
        return _this4.queue.sendEvents(sendHandler, _this4.state.eventBatchSize);
      });
    }
  }, {
    key: '_push',
    value: function _push(event) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.queue.queueEvent(event, options);
    }

    /**
     * Send the current event queue to the back end event receiver. This event is
     * debounced, see {SDKConfigInput} to override the default timing.
     *
     * This method is called by `track()` so it is not necessary to call after
     * adding events to the queue.
     */

  }, {
    key: 'send',
    value: function send() {
      var _this5 = this;

      if (!this.debouncedSend) {
        this.debouncedSend = debounce(function () {
          _this5._sendImmediately().catch(function () {
            return {};
          });
        }, this.state.eventDebounce);
      }
      this.debouncedSend();
    }

    /**
     * A convenience method that does first updates the current pageViewId in the
     * tracker state and then sends a `tracker-event` with `@type: View` and the
     * merged result of the given data and the data saved in the tracker.
     *
     * Equivalent to
     *
     * ```
     * tracker.newPageView();
     * tracker.track('trackerEvent', { type: 'View', ...data });
     * ```
     *
     */

  }, {
    key: 'trackPageView',
    value: function trackPageView(data, options) {
      this.newPageView();
      return this.track('trackerEvent', _extends({ type: 'View' }, data), options);
    }
  }]);

  return Tracker;
}();

export default Tracker;